import React from 'react'
import { SelectInput } from 'react-admin'
import { Food } from 'services/api/entities/catalog/food/types/internal/food-models'
import { deliveryTimeLogicChoices } from 'services/cfg/form'
import { GetSourceFn } from 'types/common'
import KToolTip from 'ui-shared/KTooltip'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import { OptionedProductPresetFields } from '../OptionedProductPresetFields'
import { WithSelectedProduct } from '../types'

type Props = Partial<WithSelectedProduct<Food>> & {
  getSource?: GetSourceFn
}

export const FoodPresetAdditionalFields: React.FC<Props> = ({
  getSource,
  selectedProduct,
}) => (
  <>
    <OptionedProductPresetFields
      getSource={getSource}
      selectedProduct={selectedProduct}
    />
    <LocalizedSelectInput
      label="resources.logistics.name"
      source={getSource!('logistic')}
      choices={selectedProduct?.logisticsFull ?? []}
      fullWidth
    />
    <KToolTip title="tooltip.hint.deliveryTimeLogic" placement="right-start">
      <SelectInput
        source={getSource!('deliveryTimeLogic')}
        choices={deliveryTimeLogicChoices}
        label="form.fields.deliveryTimeLogic"
        fullWidth
        resettable
      />
    </KToolTip>
  </>
)
